<template>
  <el-dialog title='提示' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose'
             width='500px'>
    <div class='p20'>
      <span>导入成功</span>
      <div class='navBtn'>
        <el-button size='small' type='primary' @click='downloadDocument("import")'>下载对账明细
        </el-button>
        <el-button size='small' type='primary' @click='downloadDocument("export")'>下载对账单模板
        </el-button>
        <el-button size='small' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    name: 'successTips',
    data() {
      return {
        dialogVisible: false,
        data: {},
      };
    },
    methods: {
      dialogOpen(data) {
        this.dialogVisible = true;
        this.data = data;
      },
      downloadDocument(field) {
        if (!this.data[field]) return this.$message.warning(field === 'import' ? '模板错误，无法转换为对账明细！' : '模板错误，无法转换为对账单模板！');
        let token = getSessionStore('token');
        const url = `/platform/settlement/supplierPortOperation/exportById?access_token=${token}&id=${this.data[field]}`;
        window.location.href = baseUrl + url;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang='scss' scoped>
  .navBtn {
    display: flex;
    align-items: center;
    margin-top: 5px;
    justify-content: flex-end;
  }

  ::v-deep {
    .el-dialog__header {
      background-color: #fff !important;
      text-align: left !important;

      .el-dialog__title {
        color: #303133 !important;
        font-size: 16px !important;
      }

      .el-dialog__headerbtn {
        top: 2px !important;

        .el-icon-close {
          color: #303133 !important;
          font-size: 20px !important;
        }
      }
    }
  }
</style>
